import { Http } from "@shared/svelte/Modules/ApiService";
import ContainerTypesStore from "@shared/svelte/Stores/ContainerTypesStore.js";
import * as _ from "lodash";
import { get } from "svelte/store";

var service = function () {
  var containerType = {};
  var containerSize = {};
  var caseSize = {};
  var packSize = {};
  var alphaSizes = [];
  const C = window["C"];
  let $rootScope = window["$rootScope"];

  var allLookups = {
    allContainerTypes: [],
    allContainerTypesCapitalized: [],
    allContainerSizes: [],
    allCaseSizes: [],
  };

  var load = function () {
    allLookups = {
      allContainerTypes: [],
      allContainerTypesCapitalized: [],
      allContainerSizes: [],
      allCaseSizes: [],
    };
    return Http(
      {
        method: "GET",
        url: "/api/" + C.APP_NAME + "/product_sizes",
      },
      function (res) {
        if (!res) {
          return;
        }
        alphaSizes = res.alpha_sizes;

        _.each(res.container_types, function (ct) {
          containerType[ct.product_type_name] = _.orderBy(ct.container_types);
          allLookups.allContainerTypes = _.uniq(
            _.concat(allLookups.allContainerTypes, ct.container_types),
          );
        });

        _.each(res.container_sizes, function (ptct) {
          containerSize[ptct.product_type_name] = {};
          _.each(ptct.container_types, function (ct) {
            containerSize[ptct.product_type_name][ct.container_type] = ct.container_sizes;
            allLookups.allContainerSizes = _.uniq(
              _.concat(allLookups.allContainerSizes, ct.container_sizes),
            );
          });
        });

        _.each(res.case_sizes, function (ptct) {
          caseSize[ptct.product_type_name] = {};
          _.each(ptct.container_types, function (ptcs) {
            caseSize[ptct.product_type_name][ptcs.container_type] = {};
            _.each(ptcs.case_sizes, function (cs) {
              caseSize[ptct.product_type_name][ptcs.container_type][cs.container_size] =
                cs.case_sizes;
              allLookups.allCaseSizes = _.uniq(_.concat(allLookups.allCaseSizes, cs.case_sizes));
            });
          });
        });

        _.each(res.pack_sizes, function (ptct) {
          packSize[ptct.product_type_name] = {};
          _.each(ptct.container_types, function (ptcs) {
            packSize[ptct.product_type_name][ptcs.container_type] = {};
            _.each(ptcs.case_sizes, function (cs) {
              packSize[ptct.product_type_name][ptcs.container_type][cs.container_size] = {};
              _.each(cs.pack_sizes, function (ps) {
                packSize[ptct.product_type_name][ptcs.container_type][cs.container_size][
                  ps.case_size
                ] = ps.pack_sizes;
              });
            });
          });
        });

        allLookups.allContainerTypesCapitalized = _.map(
          _.filter(allLookups.allContainerTypes, v => !!v),
          function (type) {
            var label = type.charAt(0).toUpperCase() + type.slice(1);
            return { value: type, label: label };
          },
        );

        if ($rootScope.$emit) {
          $rootScope.$emit("all-lookups-loaded", allLookups);
        }
        ContainerTypesStore.update(function (n) {
          return {
            containerType: containerType,
            containerSize: containerSize,
            caseSize: caseSize,
            packSize: packSize,
            alphaSizes: alphaSizes,
            load: load,
            allLookups: allLookups,
          };
        });
      },
      function (res) {},
    );
  };
  allLookups = get(ContainerTypesStore);

  if (!_.get(allLookups, "allContainerTypes.length")) {
    load();
  }

  return {
    containerType: containerType,
    containerSize: containerSize,
    caseSize: caseSize,
    packSize: packSize,
    alphaSizes: alphaSizes,
    load: load,
    allLookups: allLookups,
  };
};

service.$inject = [];

tiz.service("ProductContainerLookups", service);
export default service;
